import { faker } from "@faker-js/faker";
import capitalize from "lodash/capitalize";

import { merge } from "@/__mocks__/mockHelpers";

const fakeCodedEnumOption = (
  overrides?: DeepPartial<CodedEnumOption>,
): CodedEnumOption => {
  const label = capitalize(faker.lorem.word());
  const option: CodedEnumOption = {
    code: faker.lorem.word(),
    id: faker.string.uuid(),
    label,
  };
  return merge(option, overrides);
};

const fakeUsStateEnumOption = (
  overrides?: DeepPartial<UsStateEnumOption>,
): UsStateEnumOption => {
  const option: UsStateEnumOption = {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    externalId: faker.location.state({ abbreviated: true }),
    label: faker.location.state(),
  };
  return merge(option, overrides);
};

const fakeMultiSelectOption = (
  overrides?: DeepPartial<MultiSelectOption>,
): MultiSelectOption => {
  const text = capitalize(faker.lorem.word());
  const option: MultiSelectOption = {
    displayText: text,
    value: text,
  };
  return merge(option, overrides);
};

const fakeMultiSelectOptions = (count?: number): MultiSelectOption[] => {
  const optionCount = count ?? faker.number.int({ max: 5, min: 2 });

  // ensure all options have unique displayText
  const alreadyChosen: string[] = [];
  return faker.helpers.multiple(
    () => {
      // keep generating random values until there are enough with 0 duplicates
      while (true) {
        const option = fakeMultiSelectOption();
        if (!alreadyChosen.includes(option.displayText)) {
          alreadyChosen.push(option.displayText);
          return option;
        }
      }
    },
    {
      count: optionCount,
    },
  );
};

export { fakeCodedEnumOption, fakeMultiSelectOptions, fakeUsStateEnumOption };
